/* global ppd */
import store from 'store'
import { getVisibleUsersWithTeams } from 'VisibleUsers/selectors'

const usersWithTeamsForChartSelector = ({ currentUser, selectedUserId }) => {
  let users
  const selectedId = selectedUserId ? selectedUserId.toString() : null

  if (currentUser.level === 3 || currentUser.level === 2) {
    users = [{ full_name: 'All users', id: 'any' }, ...getVisibleUsersWithTeams(store.getState())]
  } else {
    users = [currentUser]
  }

  return users.map(user => decorateUser(user, selectedId))
}

function decorateUser (user, selectedId) {
  return {
    id: user.id,
    text: user.full_name,
    imageSrc: (user.avatar_thumb_url || ppd.assetPath('avatar-default.png')),
    selected: user.id.toString() === selectedId,
    deleted_at: user.deleted_at,
    read_only: user.read_only
  }
}

export default usersWithTeamsForChartSelector
